module.exports = __webpack_public_path__ + "img/Gallery_1_04.b317e31b.jpeg";